import React, { useEffect, useState } from "react";
import Error from "../../../pages/404";
import RecentCandidates from "./components/RecentCandidates";
import DashboardBanner from "./components/DashboardBanner";
import EmployerLayout from "../../ui/layout/EmployerLayout";
import { Row, Col, Container } from "react-bootstrap";
import { createUseStyles } from "react-jss";
import { Company, CompanyLogo, EmployerRoles, getUserInfo, isUserLogin, setUserInfo, signIN, singOut } from "../../../common/userfuctions";
import { useRouter } from "next/router";
import { GetUserCompanies } from "../../../pages/api/modules/Companies";
import { GetEmployerDashboardData, GetEmployerRole } from "../../../pages/api/Employer/Employer";
import { deleteCookie, setCookie } from "cookies-next";
import DashboardCurrentlyHiring from "./components/DashboardCurrentlyHiring";
import DashboardInterviews from "./components/DashboardInterviews";
import dynamic from "next/dynamic";
import OnBordingModal from "../OnBordingModal";
import DashboardFilterModal from "./components/DashboardFilterModal";
import Loader from "../../../components/Loader"
import { App } from "antd";

function Dashboard() {
  const router = useRouter();
  const { message } = App.useApp();
  const [dashboardData, setDashboardData] = useState("");
  const [currentlyHirings, setCurrentlyHirings] = useState(0);
  const [candidates, setCandidates] = useState([]);
  const [interviews, setInterviews] = useState([]);
  const [companyData, setCompanyData] = useState({});
  const [loading, setLoading] = useState(true);
  const [candidatesApply, setCandidatesApply] = useState([]);
  const [chartData, setChartData] = useState({});
  const [averageStatusData, setAverageStatusData] = useState([]);
  const [steps, setSteps] = useState({});
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [activeJobs, setActiveJobs] = useState([]);
  const [showDashboard, setShowDashboard] = useState(false);
  const [employerRoles , setEmployerRoles] = useState(null);
  const [showOnBoardingProcess , setShowOnBoardingProcess] = useState(false);
  const [finalData, setFinalData] = useState({
    jobId: 0,
    interviewDate: "",
  });

  const parseCookies = (cookieHeader) => {
    const cookies = {};
    if (cookieHeader) {
      cookieHeader.split(";").forEach((cookie) => {
        const [name, value] = cookie.split("=");
        cookies[name.trim()] = decodeURIComponent(value);
      });
    }
    return cookies;
  };
  const ValidateEmployer = async () => {
    const isEmployer = await isUserLogin();

    if (!isEmployer) {
      router.push("/employer?show_signup=true");
    }
  };

  const ValidateEmployeeCompany = async () => {
    const cookies = parseCookies(document.cookie);
    const AccessToken = cookies?.HireSide_Employers_AccessToken;
    const CompanyCode = cookies?.companyCode;

    if (!CompanyCode) {

      const response = await GetUserCompanies(AccessToken);
      if(response?.Status == -1){
        singOut();
        router.push("/employer?show_signup=true");
      }

      if (response?.Status) {
        const companies = response?.Companies;
        setCookie("companies", JSON.stringify(companies) || "", { maxAge: 60 * 60 * 24 * 7 });
        setCookie("companyCode", companies[0] || "", { maxAge: 60 * 60 * 24 * 7 });
        setShowDashboard(true);
      }
    } else {

      setShowDashboard(true);
    }
  };



  const onAddCompany = () => {
    router.push("/employer/add-company");
  };

  const onClaimCompany = async () => {
    const access = await checkEmployerAccess();
    if (access) {
      setVisible(true);
    } else {
      message.warning("Employer Access required");
    }
  };

  const getData = async (filters) => {
    setAverageStatusData([]);
    const res = await GetEmployerDashboardData(filters);
    if (res.Status == 1) {
      setSteps(res?.Data?.Steps);
      setShowOnBoardingProcess(res?.Data?.Steps?.CompanyStatus == 0 ||
      res?.Data?.Steps?.CompanyStatus == 2 ||
      res?.Data?.Steps?.JobStatus == 0 ||
      res?.Data?.Steps?.JobStatus == 2 ||
      res?.Data?.Steps?.InviteMemberStatus == 2 ||
      res?.Data?.Steps?.NoJobHiringManager == 2
          ? true
          : false);

      let userInfo = getUserInfo();
      setUserInfo({
        ...userInfo,
        "Steps": res?.Data?.Steps
      });
      setDashboardData(res?.Data);
      setCurrentlyHirings(res?.Data);
      setActiveJobs(res?.Data?.ActiveJobs);
      setCandidates(res?.Data?.Candidates);
      setInterviews(res?.Data?.Interviews);
      setCandidatesApply(res?.Data?.CandidatesApplied);
      setCompanyData(res?.Data?.Companies[res?.Data?.CompanyCode]);
      CompanyLogo.setCompanyLogo(res?.Data?.Companies[res?.Data?.CompanyCode]?.CompanyLogo)

      setChartData(res?.Data?.JobHistoryCounterByStatus);

      setAverageStatusData(res.Data.AverageStatusData);
      setLoading(false);
    } else {
      setLoading(false);
      console.error(res.Error);
    }
  };

  useEffect(() => {
    router.push({
      pathname:"/employer/home",
    })
    const initializeData = async () => {
      
      deleteCookie("CandidateCheckboxFilters")
      await ValidateEmployer();
      await ValidateEmployeeCompany();
      await getData();
       
      const roles = EmployerRoles.getEmployerRoles();
      if (roles && roles !== null) {
        setEmployerRoles(Number(roles));

      } else {
        const code = Company.getCompany();
        if (code) {
          const res = await GetEmployerRole(code);
          const Role = Number(res?.Data?.Role);
          EmployerRoles.setEmployerRoles(Role);
          setEmployerRoles(Role);
        }
      }
      setLoading(false);
    };

    initializeData();
  }, []);


  const styles = useStyles();

  return (
    <Error/>
    // <>
    //   {loading && <Loader />}
    //   {
    //    Object.keys(steps).length > 0  &&

    //    <EmployerLayout employerInfo={{Steps : steps}}>
    //     {
    //     showOnBoardingProcess || steps?.InviteMemberStatus > 1 ? (


    //       steps && <OnBordingModal steps={steps} loading={loading} getData={getData}    />


    //     ) : (
    //       (showDashboard &&
    //         <div className={styles.main}>
    //           <div className={styles.mainContainer}>
    //             <Row>
    //               <Col>
    //                 <Row>
    //                   <DashboardBanner companyHeader={companyData?.CompanyHeader} />
    //                 </Row>

    //                 <DashboardCurrentlyHiring currentlyHirings={currentlyHirings} setIsModalOpen={setIsModalOpen} employerRoles={employerRoles} />
    //                 <DashboardInterviews
    //                   interviews={interviews}
    //                   getData={getData}
    //                   setFinalData={setFinalData}
    //                   finalData={finalData}
    //                 />
    //                 <RecentCandidates candidates={candidates} />
    //               </Col>
    //             </Row>
    //           </div>
    //           <DashboardFilterModal
    //             isModalOpen={isModalOpen}
    //             setIsModalOpen={setIsModalOpen}
    //             activeJobs={activeJobs}
    //             getData={getData}
    //             setFinalData={setFinalData}
    //             finalData={finalData}
    //           />
    //         </div>
    //       )
    //     )}
    //   </EmployerLayout>
    //   }

    // </>
  );
}

const useStyles = createUseStyles({
  row:{
    margin:"0 !important"
  },
  mainContainer: {
    justifyContent: "center",
    paddingTop: 25,
    paddingBottom: 25,
  },
  ContainerGap: {
    display: "flex",
    flexDirection: "column",
    gap: "15px",
  },
});

export default dynamic(() => Promise.resolve(Dashboard), { ssr: false });
